

































import Vue from "vue";
import vClickOutside from "v-click-outside";

export default Vue.extend({
  name: "BaseModalWindow",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    showCloseIcon: Boolean,
  },
  computed: {
    keymap: function () {
      return {
        esc: this.exit,
      };
    },
  },
  methods: {
    exit() {
      this.$emit("close");
    },
    onClickOutside(event) {
      //console.log("Clicked outside. Event: ", event);
      this.$emit("clickOutside");
    },
    onDblClick(event: MouseEvent) {},
  },
});
